import { EventBus } from '@/core/events/bus'
import { VueConstructor } from 'vue/types/umd'

const EventBusPlugin = {
  install(Vue: VueConstructor) {
    ;(Vue as any).$event = EventBus
    Vue.prototype.$event = EventBus
  },
}

export { EventBusPlugin }
